export default "__VITE_ASSET__HT4OEeof__"